module.exports = __webpack_public_path__ + "img/bintang.848eb562.svg";